import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2 } from 'lucide-react';
export function ProductSection() {
  const tomos = [{
    emoji: '📘',
    title: 'Tomo 1 — El Eje Intestino-Cerebro',
    items: ['El mecanismo exacto de la niebla mental', 'El Nervio Vago y el Sistema Nervioso Entérico', 'Test de la Nube de 20 preguntas', 'Plan de acción desde el Día 1'],
    color: 'border-blue-500/30'
  }, {
    emoji: '📗',
    title: 'Tomo 2 — Nutrición para Neurotransmisores',
    items: ['Qué comer para fabricar Serotonina, Dopamina y GABA', 'Semáforo de alimentos adaptado a la feria argentina', 'Menú de 14 días completo'],
    color: 'border-green-500/30'
  }, {
    emoji: '📙',
    title: 'Tomo 3 — El Protocolo del Nervio Vago',
    items: ['Gárgaras, respiración 4-7-8, masaje ILU', 'Yoga neuro-digestivo', 'Plan de 14 días para fortalecer el cable maestro cerebro-intestino'],
    color: 'border-orange-500/30'
  }, {
    emoji: '📕',
    title: 'Tomo 4 — Detox de Neurotoxinas',
    items: ['Protocolo de las 2 fases del hígado', 'Quelación con cilantro y clorela', 'Sistema Glinfático', 'Plan de 3 días de limpieza profunda'],
    color: 'border-red-500/30'
  }, {
    emoji: '📓',
    title: 'Tomo 5 — El Ritual de Claridad',
    items: ['La Regla del 80/20', 'Comer afuera sin niebla', 'El Protocolo de Re-inicio', 'Plan de Longevidad Cognitiva para los próximos 20 años'],
    color: 'border-gray-500/30'
  }];
  const includes = ['Plan diario listo para aplicar desde el primer día', 'Recetas con ingredientes de tu feria argentina', 'Tracker de síntomas con criterios de medición', 'Checklist imprimible por etapa', 'Errores frecuentes y cómo evitarlos', 'Bibliografía científica completa'];
  return <section className="py-24 bg-brand-dark" data-id="element-224">
      <div className="container mx-auto px-4" data-id="element-225">
        <div className="max-w-5xl mx-auto" data-id="element-226">
          <div className="text-center mb-16" data-id="element-227">
            <motion.div initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} data-id="element-228">
              <h2 className="text-4xl md:text-5xl font-bold mb-4 text-brand-gold font-[Poppins,_sans-serif]" data-id="element-229">
                🏆 SISTEMA CLARIDAD DIGESTIVA™
              </h2>
              <p className="text-2xl text-white font-medium mb-2" data-id="element-230">
                5 Tomos + 5 Bonos — Sistema completo de 21 días
              </p>
              <p className="text-xl text-brand-light" data-id="element-231">
                300+ páginas. Todo resuelto.
              </p>
            </motion.div>
          </div>

          <h3 className="text-2xl font-bold mb-8 text-center" data-id="element-232">
            📚 5 TOMOS COMPLETOS
          </h3>

          <div className="grid gap-6 mb-16" data-id="element-233">
            {tomos.map((tomo, index) => <motion.div key={index} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: index * 0.1
          }} className={`bg-brand-black p-6 md:p-8 rounded-2xl border ${tomo.color} flex flex-col md:flex-row gap-6 items-start hover:bg-gray-900/50 transition-colors`} data-id="element-234">
                <div className="text-5xl shrink-0" data-id="element-235">{tomo.emoji}</div>
                <div data-id="element-236">
                  <h4 className="text-xl font-bold text-white mb-3" data-id="element-237">
                    {tomo.title}
                  </h4>
                  <ul className="space-y-2" data-id="element-238">
                    {tomo.items.map((item, i) => <li key={i} className="flex items-start gap-2 text-gray-300" data-id="element-239">
                        <CheckCircle2 className="w-5 h-5 text-brand-light shrink-0 mt-0.5" data-id="element-240" />
                        <span data-id="element-241">{item}</span>
                      </li>)}
                  </ul>
                </div>
              </motion.div>)}
          </div>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="bg-brand-green/10 border border-brand-green/30 rounded-2xl p-8 md:p-10" data-id="element-242">
            <h4 className="text-xl font-bold text-white mb-6 text-center" data-id="element-243">
              Cada tomo incluye:
            </h4>
            <div className="grid md:grid-cols-2 gap-4" data-id="element-244">
              {includes.map((item, index) => <div key={index} className="flex items-start gap-3" data-id="element-245">
                  <CheckCircle2 className="w-6 h-6 text-brand-light shrink-0" data-id="element-246" />
                  <span className="text-gray-200" data-id="element-247">{item}</span>
                </div>)}
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}